import { queryOptions } from '@tanstack/react-query'
import { surveyApi } from '../apis/surveys.api'

const {
  getSurveyWithConfig,
  getSurvey,
} = surveyApi()

export function getSurveyWithConfigQueryOptions(surveyId: string) {
  return queryOptions({
    queryKey: ['get-survey-with-config', surveyId],
    queryFn: () => {
      return getSurveyWithConfig(surveyId)
    },
    refetchOnWindowFocus: false,
  })
}

export function getSurveyOptions(surveyId: string) {
  return queryOptions({
    queryKey: ['get-survey', surveyId],
    queryFn: () => {
      return getSurvey(surveyId)
    },
    refetchOnWindowFocus: false,
  })
}
